import {Component, Inject, OnInit} from '@angular/core';
import {Announcement} from '../announcement.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-broadcast-dialog',
    templateUrl: './broadcast-dialog.component.html',
    styleUrls: ['./broadcast-dialog.component.css']
})
export class BroadcastDialogComponent implements OnInit {

    // Injected Properties
    broadcast: Announcement;

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<BroadcastDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) { }

    // Event Functions
    ngOnInit() {
        this.broadcast = this.data.broadcast;
    }

    close() {
        // PRE: the close button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }

    // Methods
}
